'use strict';

import { Autoplay } from "swiper/modules";

export function dyanne_platformInitProductGallerySwiper(element) {

    let gallerySwiper = null;

    const swiperInit = () => {
        gallerySwiper = new Swiper(
            element,
            {
                loop: true,
                scrollbar: {
                    el: '.swiper-scrollbar'
                },
                pagination: {
                    el: ".swiper-pagination",
                    type: "fraction",
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 12
                    },
                    1024: {
                        slidesPerView: 1,
                        spaceBetween: 0
                    },
                    1280: {
                        slidesPerView: 2,
                        spaceBetween: 8
                    }
                }
            }
        );
    }

    const swiperToggler = () => {
        if (window.innerWidth >= 1390 ) {
            if (gallerySwiper instanceof Swiper) {
                gallerySwiper.destroy( true, true );
            }
        } else {
            swiperInit();
        }
    }

    addEventListener( 'resize', swiperToggler, { passive: true } );
    swiperToggler();
}

export function dyanne_platformSyncVariationDropdown(element) {

    const variationDropdown = element.parentNode.parentNode.querySelector('select[name="' + element.name + '"]');

    console.log(variationDropdown);
    if (!variationDropdown) {
        return;
    }

    variationDropdown.value = element.value;

    jQuery(variationDropdown).trigger('change');

    // Before we continue, we need to check if the variation is available.
    if (element.nextSibling.classList.contains('out-of-stock')) {
        window.dyanne_platformToggleInstocknotifierForm(element, 'show' );
        return;
    } else {
        window.dyanne_platformToggleInstocknotifierForm(element, 'hide');
    }
}

/**
 * Add product (variation) to cart and update add to cart button.
 *
 * @param {*} element
 * @returns
 */
export function dyanne_platformAddToCart(element) {

    // Check if the product is a variable or simple product.
    const productType = element.classList.contains('product-type-variable') ? 'variable' : 'simple';
    const miniCart = document.querySelector('#minicart');
    const miniCartFragments = document.querySelector('#minicart-fragments');
    let variationForm = null;
    let formData = null;
    let productBlock = null;
    let addtocartButton = null;
    let variationId = null;

    // Handle variable product data.
    if ('variable' === productType) {
        variationForm = element.parentNode.parentNode.parentNode;
        productBlock = variationForm.closest('.product');
        addtocartButton = element;
        variationId = variationForm.querySelector('input[name="variation_id"]').value;

        console.log('Processing variable product: ', variationId);

        if (!variationId || '0' === variationId) {
            return;
        }

        variationForm.querySelector('input[name="product_id"]').value = variationId;

        addtocartButton.classList.add('btn-loading');
        addtocartButton.classList.add('opacity-50');
        addtocartButton.disabled = true;

        if (!variationForm) {
            return;
        }

        formData = jQuery(variationForm).serialize();
    }

    // Handle simple product data.
    if ('simple' === productType) {
        addtocartButton = element;
        productBlock = addtocartButton.closest('.product');
        addtocartButton.classList.add('btn-loading');
        addtocartButton.classList.add('opacity-50');
        addtocartButton.disabled = true;

        if (!productBlock) {
            return;
        }

        formData = jQuery(productBlock).find('form.cart').serialize();
    }

    jQuery.post(wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'), formData, function (response) {
        if (response.error) {
            Modal.alert(response.notices.error[0].notice, { top: (window.innerHeight * 0.5) });
            addtocartButton.classList.remove('btn-loading');
            addtocartButton.classList.remove('opacity-50');
            addtocartButton.disabled = false;
        } else {
            addtocartButton.classList.remove('btn-loading');
            addtocartButton.classList.add('btn-done');

            setTimeout(
                function () {
                    addtocartButton.disabled = false;
                    addtocartButton.classList.remove('opacity-50');
                    addtocartButton.classList.remove('btn-done');
                    if (variationForm) {
                        variationForm.reset();
                    }

                    Alpine.$data(miniCart).minicart = true;
                    Alpine.$data(miniCart).added = true;
                    Alpine.$data(productBlock).quickcart = false;

                    miniCartFragments.innerHTML = response.fragments['div.widget_shopping_cart_content'];

                    // Update cart counters (everywhere).
                    dyanne_platformFetchCartCount().then(cartCount => {
                        window.dispatchEvent(new CustomEvent('update-cart-count', { detail: cartCount }));
                    });
                },
                750
            );
        }
    });
}

export function dyanne_platformInitRelatedProductsSwiper(element) {
    let gallerySwiper = null;

    const updateNavigationVisibility = (e) => {
        const swiper = e;
        if (swiper.slides.length <= swiper.params.slidesPerView) {
            swiper.el.querySelector('.swiper-button-next').classList.add('hidden');
        } else {
            swiper.el.querySelector('.swiper-button-next').classList.remove('hidden');
        }
    }

    gallerySwiper = new Swiper(
        element,
        {
            navigation: {
				prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            loop: true,
            slidesPerView: 3,
            spaceBetween: 20,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            on: {
                init: updateNavigationVisibility,
                slideChange: updateNavigationVisibility,
                resize: updateNavigationVisibility,
                breakpoint: updateNavigationVisibility,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.6,
                    spaceBetween: 5,
                    navigation: false,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                    navigation: {
						prevEl: '.swiper-button-prev',
                        nextEl: '.swiper-button-next',
                    },
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                }
            },
        }
    );

}

export function dyanne_platformMarquee(selector, speed) {
    const parentSelector = selector.querySelector('.marquee');
    const clone = parentSelector.innerHTML;
    const firstElement = parentSelector.children[0];
    let i = 0;
    parentSelector.insertAdjacentHTML('beforeend', clone);
    setInterval(function () {
        firstElement.style.marginLeft = `-${i}px`;
        if (i > firstElement.clientWidth) {
            i = 0;
        }
        i = i + speed;
    }, 0);
}
